// extracted by mini-css-extract-plugin
export var container = "searchBox-module--container--clGn3";
export var input = "searchBox-module--input--pxlU9";
export var search = "searchBox-module--search--Aai5t";